import React from 'react';

import { Button } from '@/components/ui/button';

type BlockMenuButtonProps = {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
};

export default function BlockTypeButton({ label, icon, onClick }: BlockMenuButtonProps) {
  return (
    <Button
      variant="ghost"
      className="p-1.5 flex flex-col h-auto"
      onClick={(ev) => {
        ev.stopPropagation();
        onClick();
      }}
    >
      <div className="mb-0.75 w-full bg-muted flex justify-center p-1 border border-border">
        {icon}
      </div>
      <span className="text-sm">{label}</span>
    </Button>
  );
}
